import { cn } from '../../lib/utils';

export default function AgentCard({ agent, icon: Icon, selected, onClick }) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full p-3 rounded-sm border text-left transition-all duration-200",
        "hover:border-[#334155] hover:-translate-y-0.5",
        selected 
          ? "border-[#0EA5E9] bg-[#0EA5E9]/10" 
          : "border-[#1E293B] bg-[#1E293B]/50"
      )}
      data-testid={`agent-card-${agent.id}`}
    >
      <div className="flex items-start gap-3">
        <div 
          className="w-8 h-8 rounded-sm flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${agent.color}20`, color: agent.color }}
        >
          <Icon className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-[#EDEDED] truncate">{agent.name}</h3>
          <p className="text-xs text-[#64748B] truncate mt-0.5">{agent.description}</p>
        </div>
      </div>
    </button>
  );
}
